import Vue from "vue";
import Vuex from "vuex";
import main from "../../main";

Vue.use(Vuex);

const namespaced = true;

// You can use it as state property
const state = {};

// You can use it as a state getter function (probably the best solution)
const getters = {};

// Mutation for when you use it as state property
const mutations = {
  allTabsRedirect(state, address) {
    main.$router.push(address);
  }
};

const actions = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
